import { ReservationQuestionDto } from "@/api/generated/generatedTypes";
import { EventQuestionSlug } from "@/api/reservation/dto";

export const getPathForReservationQuestion = (question: ReservationQuestionDto): string => {
  switch (question.slug) {
    case EventQuestionSlug.WHEN:
      return "event.preferredTimes";
    case EventQuestionSlug.WHERE:
      return "event.preferredLocationIds";
    case EventQuestionSlug.MESSAGE_FOR_GUESTS:
      return "event.messageForGuests";
    case EventQuestionSlug.PREFERRED_LANGUAGE:
      return "dinnerPreference.preferredLanguage";
    case EventQuestionSlug.PREFERRED_COST:
      return "dinnerPreference.preferredCost";
    case EventQuestionSlug.DIETARY_RESTRICTIONS:
      return "dinnerPreference.dietaryRestrictions";
    default:
      console.warn("Unhandled question slug in getPathForReservationQuestion:", question.slug);
      return "";
  }
};
